export const IconLoaderWhiteLarge: {
  name: 'icon_loader_white_large-a3af4bc83c30'
} = {
  name: 'icon_loader_white_large-a3af4bc83c30'
}
